import {AxiosRequestHeaders, AxiosResponse} from 'axios'
import {isResponseSuccessful} from '../utils/helper'
import {ISearchService, SearchOptions} from './utils/types'
import {GenericSearch} from '../utils/types'
import {SearchTypes} from '../utils/enums'
import BaseService from './base_service'
import {useAuthHeader} from '../utils/hooks/useAuthHeader'

class SearchService extends BaseService implements ISearchService {
    async genericSearch(searchStr: string, type: SearchTypes, opt?: SearchOptions): Promise<GenericSearch[]> {
        const filter = opt?.filter ? `${opt?.filter.join(',')}` : ''
        const strict = type === SearchTypes.product ? `${!!opt?.strict}` : ''
        const unit = opt?.unit || ''
        const authHeader: AxiosRequestHeaders = await useAuthHeader()
        const response: AxiosResponse<GenericSearch[]> = await this.client.get(`/api/private/search/${type}`, {
            params: {
                searchStr,
                filter,
                strict,
                unit
            },
            headers: {
                ...authHeader
            }
        })
        if (!isResponseSuccessful(response)) {
            console.error(`Failed to get search values for: ${type}`)
            return Promise.reject()
        }
        return Promise.resolve(response.data)
    }
}

export default SearchService
